import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import CustomersPage from "../modules/Customers/CustomersPage";

export function Customers() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "customers-page-title",
    defaultMessage: "Customers"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <CustomersPage/>;
}
